import { render, staticRenderFns } from "./PhotosList.vue?vue&type=template&id=4ab852c8"
import script from "./PhotosList.vue?vue&type=script&lang=js"
export * from "./PhotosList.vue?vue&type=script&lang=js"
import style0 from "./PhotosList.vue?vue&type=style&index=0&id=4ab852c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports